import { useLayoutEffect, useRef } from 'react';

/* segmentado: o polegar desliza até a opção escolhida */
export function Seg<T extends string>({ options, value, onChange, labelledBy, id }: {
  options: ReadonlyArray<{ value: T; label: string }>;
  value: T;
  onChange: (v: T) => void;
  labelledBy?: string;
  id?: string;
}) {
  const box = useRef<HTMLDivElement>(null);
  const thumb = useRef<HTMLSpanElement>(null);
  const first = useRef(true);

  useLayoutEffect(() => {
    const seg = box.current!, th = thumb.current!;
    const place = (anim: boolean) => {
      const b = seg.querySelector<HTMLButtonElement>('button[aria-pressed="true"]');
      if (!b) return;
      if (!anim) th.style.transition = 'none';
      th.style.width = b.offsetWidth + 'px';
      th.style.transform = `translateX(${b.offsetLeft - 3}px)`;
      if (!anim) requestAnimationFrame(() => { th.style.transition = ''; });
    };
    place(!first.current);
    first.current = false;
    const ro = new ResizeObserver(() => place(false));
    ro.observe(seg);
    return () => ro.disconnect();
  }, [value]);

  return (
    <div className="seg" id={id} ref={box} role="group" aria-labelledby={labelledBy}
      style={{ gridTemplateColumns: `repeat(${options.length},1fr)` }}>
      <span className="thumb" aria-hidden="true" ref={thumb} />
      {options.map(o => (
        <button key={o.value} type="button" aria-pressed={o.value === value} onClick={() => onChange(o.value)}>{o.label}</button>
      ))}
    </div>
  );
}
